import { Fragment } from 'react';

import style from './DataHubLinks.module.css';

const DataHubLinks = () => {
  if (!import.meta.env.VITE_DHY_BASE_URL) {
    return <Fragment />;
  } else {
    return (
      <div className={style.sectionContainer}>
        <span className={style.sectionTitleText}>Data Hub</span>
        <span className={style.sectionBodyText}>Search for times, explore programs, and analyze leaderboards.</span>
        <a href={import.meta.env.VITE_DHY_BASE_URL} className={style.sectionButton}>
          <span className={style.sectionButtonText}>Visit Data Hub</span>
        </a>
      </div>
    );
  }
};

export default DataHubLinks;